import { forwardRef } from 'react'
import { cn } from '../lib/cn.js'
import { Campo } from './Campo.js'

export type InputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> & {
  rotulo: string
  dica?: string | undefined
  erro?: string | undefined
  /** Prefixo fixo, tipo "R$" ou "(11)". Fica dentro da caixa, não no placeholder. */
  prefixo?: string | undefined
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { rotulo, dica, erro, prefixo, className, required, ...resto },
  ref,
) {
  return (
    <Campo rotulo={rotulo} dica={dica} erro={erro} obrigatorio={required}>
      {({ id, descritoPor, invalido }) => (
        <span className={cn('du-entrada', prefixo && 'du-entrada--com-prefixo', className)}>
          {prefixo ? <span className="du-entrada__prefixo">{prefixo}</span> : null}
          <input
            ref={ref}
            id={id}
            aria-describedby={descritoPor}
            aria-invalid={invalido || undefined}
            required={required}
            {...resto}
          />
        </span>
      )}
    </Campo>
  )
})
